import React from "react";
//import addons from "react-addons/index";
import { Row, Col, Container, Card, CardHeader, CardBody } from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import { ProtectedRoute } from "../../ProtectedRoute";
import getViewContext from "../Context/ViewContext";
import { Link } from "react-router-dom";

//var classSet = React.classSet;


export default function ViewAboutTheGroup(props) {
    
    
      
      return (
      
      <ProtectedRoute>
      <Container>
        <Row noGutters  className="page-header py-4">
            <PageTitle
                sm="4"
                title="About The Group"
                className="text-sm-left"
            />
        </Row>
        <Row className="px-3 py-5" > 
            <Col lg="3" className="flex-column align-items-stretch">
                <Card className="h-50 mb-4">
                  <Link to="/aboutthegroup">
                    <CardHeader className="border-bottom">
                    <h6 className="m-0">About The Group</h6>
                    </CardHeader>
                    <CardBody className="p-0">
                        <div className="blog-comments__content">
                        <p className="m-2 my-1 mb-2 text-muted">
                            A brief history of the Floorcredit Credit Group
                        </p>
                        </div>
                  </CardBody>
                  </Link>
                </Card> 
                <Card className="h-50 mb-4">
                  <Link target="_blank" to="/scoringmodel.pdf">
                    <CardHeader className="border-bottom">
                    <h6 className="m-0">CCI Scoring Model</h6>
                    </CardHeader>
                    <CardBody className="p-0">
                        <div className="blog-comments__content">
                        <p className="h-25 m-2 my-1 mb-2 text-muted">
                            A description of how the CCI Scoring Model is calculated.
                        </p>
                        </div>
                    </CardBody>
                    </Link>
                </Card>   
              </Col>
              <Col lg="3" className="flex-column align-items-stretch">
                <Card className="h-50 mb-4">
                  <Link target="_blank" to="/bylawsrtfccg.pdf">
                    <CardHeader className="border-bottom">
                    <h6 className="m-0">BYLAWS</h6>
                    </CardHeader>
                    <CardBody className="p-0">
                        <div className="blog-comments__content">
                        <p className=" m-2 my-1 mb-2 text-muted">
                            A copy of the current round table BYLAWS
                        </p>
                        </div>
                  
                    </CardBody>
                    </Link>
                </Card> 
                <Card className="h-50 mb-4">
                  <Link target="_blank" to="/maillist.pdf">
                  <CardHeader className="border-bottom">
                    <h6 className="m-0">Member Roster</h6>
                    </CardHeader>
                    <CardBody className="p-0">
                        <div className="blog-comments__content">
                        <p className="h-25 m-2 my-1 mb-2 text-muted">
                            A current list of all members and contacts.
                        </p>
                        </div>

                  </CardBody>
                    </Link>
                </Card> 
            </Col>
            <Col lg="3" className="flex-column align-items-stretch">
                <Card className="h-50 mb-4">
                  <Link to="/ViewRTFCCG">
                    <CardHeader className="border-bottom">
                    <h6 className="m-0">RTFCCG</h6>
                    </CardHeader>
                    <CardBody className="p-0">
                        <div className="blog-comments__content">
                        <p className="h-25 m-2 my-1 mb-2 text-muted">
                            A list of current officers, previous presidents, and award winners
                        </p>
                        </div>

                    </CardBody>
                  </Link>
                </Card> 
            </Col>
        </Row>
      </Container>
      </ProtectedRoute>
    );
    
    }
/*
export function useViewContext()
{
  return viewContext;
}*/
